(function () {
    window.VRPanelSlotManager = {
        SLOTS: {
            CENTER: { name: 'CENTER', x: 0, z: -1.2 },
            RIGHT: { name: 'RIGHT', x: 0.79, z: -2.49 },
            LEFT: { name: 'LEFT', x: -0.8, z: -2.5 }
        },

        PANEL_KEYS: {
            CENTER_BLOCK: 'CENTER_BLOCK',
            RIGHT_PANEL: 'RIGHT_PANEL',
            LEFT_PANEL: 'LEFT_PANEL'
        },

        getStep: function () {
            const el = document.querySelector('[main-elements-moving]');
            if (el && el.components && el.components['main-elements-moving']) {
                const step = el.components['main-elements-moving'].data.currentStep;
                return (typeof step === 'number' && !isNaN(step)) ? ((step % 3) + 3) % 3 : 0;
            }
            return 0;
        },

        normalizePanelKey: function (panelElOrId) {
            if (!panelElOrId) return 'CENTER_BLOCK';
            let id = typeof panelElOrId === 'string' ? panelElOrId : panelElOrId.id;
            if (id.startsWith('#')) id = id.substring(1);

            if (id === 'left-panel-2' || id === 'LEFT_PANEL') return 'LEFT_PANEL';
            if (id === 'right-container' || id === 'RIGHT_PANEL') return 'RIGHT_PANEL';
            if (id === 'large-center-panel' || id === 'watchlist-table' || id === 'search-center-panel' || id === 'CENTER_BLOCK') return 'CENTER_BLOCK';
            return 'CENTER_BLOCK';
        },

        getSlotForPanel: function (panelElOrId, step) {
            if (step === undefined || step === null) step = this.getStep();
            step = ((step % 3) + 3) % 3;

            const key = this.normalizePanelKey(panelElOrId);

            if (key === 'CENTER_BLOCK') {
                if (step === 0) return 'CENTER';
                if (step === 1) return 'RIGHT';
                if (step === 2) return 'LEFT';
            } else if (key === 'RIGHT_PANEL') {
                if (step === 0) return 'RIGHT';
                if (step === 1) return 'LEFT';
                if (step === 2) return 'CENTER';
            } else if (key === 'LEFT_PANEL') {
                if (step === 0) return 'LEFT';
                if (step === 1) return 'CENTER';
                if (step === 2) return 'RIGHT';
            }
            return 'CENTER';
        },


        getPanelInSlot: function (slotName, step) {
            if (step === undefined || step === null) step = this.getStep();
            step = ((step % 3) + 3) % 3;
            slotName = (slotName || 'CENTER').toUpperCase();

            if (slotName === 'CENTER') {
                if (step === 0) return 'CENTER_BLOCK';
                if (step === 1) return 'LEFT_PANEL';
                if (step === 2) return 'RIGHT_PANEL';
            } else if (slotName === 'RIGHT') {
                if (step === 0) return 'RIGHT_PANEL';
                if (step === 1) return 'CENTER_BLOCK';
                if (step === 2) return 'LEFT_PANEL';
            } else if (slotName === 'LEFT') {
                if (step === 0) return 'LEFT_PANEL';
                if (step === 1) return 'RIGHT_PANEL';
                if (step === 2) return 'CENTER_BLOCK';
            }
            return 'CENTER_BLOCK';
        },

        getActiveCenterElement: function () {
            const searchPanel = document.querySelector('#search-center-panel');
            if (searchPanel && searchPanel.getAttribute('visible') !== 'false' && searchPanel.getAttribute('visible') !== false) {
                return searchPanel;
            }
            const watchlistTable = document.querySelector('#watchlist-table');
            if (watchlistTable && watchlistTable.getAttribute('visible') !== 'false' && watchlistTable.getAttribute('visible') !== false) {
                return watchlistTable;
            }
            return document.querySelector('#large-center-panel');
        },

        getSlotTransform: function (panelElOrId, slotName) {
            slotName = (slotName || 'CENTER').toUpperCase();
            let panelId = typeof panelElOrId === 'string' ? panelElOrId : (panelElOrId ? panelElOrId.id : '');
            if (panelId.startsWith('#')) panelId = panelId.substring(1);

            let x = 0, z = -1.2;
            if (slotName === 'LEFT') {
                x = -0.8; z = -2.5;
            } else if (slotName === 'RIGHT') {
                x = 0.79; z = -2.49;
            } else {
                x = 0; z = -1.2;
            }

            let y = 2.2;
            if (panelId === 'watchlist-table') {
                y = (slotName === 'CENTER') ? 2.57 : 2.65;
            } else if (panelId === 'search-center-panel') {
                y = 2.2;
            } else if (panelId === 'large-center-panel') {
                y = 1.6;
            } else {
                y = 2.2;
            }

            let rot = '0 0 0';
            if (slotName === 'CENTER') {
                rot = (panelId === 'large-center-panel') ? '0 -45 0' : '0 0 0';
            } else {
                if (panelId === 'large-center-panel') {
                    const _chartTypeElLocal = document.querySelector('[chart-type-control]');
                    const _isMmapLocal = _chartTypeElLocal?.getAttribute('chart-type-control')?.selectedPrimeAction === 'mmap';
                    const _mmapModeLocal = _isMmapLocal ? ((window.MarketMapModeSwitching && window.MarketMapModeSwitching.getCurrentMode) ? window.MarketMapModeSwitching.getCurrentMode() : '2d') : null;
                    const _isMmap2D = _isMmapLocal && _mmapModeLocal === '2d';

                    if (!_isMmap2D) {
                        rot = (slotName === 'LEFT') ? '0 0 0' : '0 -90 0';
                    } else {
                        rot = (slotName === 'LEFT') ? '0 45 0' : '0 -45 0';
                    }
                } else {
                    rot = (slotName === 'LEFT') ? '0 45 0' : '0 -45 0';
                }
            }

            return {
                pos: `${x} ${y} ${z}`,
                rot: rot,
                x: x,
                y: y,
                z: z
            };
        },

        isPanelRepositioned: function (panelElOrId, defaultPosStr) {
            if (!panelElOrId) return false;
            let panelId = typeof panelElOrId === 'string' ? panelElOrId : panelElOrId.id;
            if (panelId.startsWith('#')) panelId = panelId.substring(1);

            const configureControlElement = document.querySelector('#configure-control');
            const configureControlAttr = configureControlElement ? configureControlElement.getAttribute('configure-control') : null;
            const isManualPosition = !!(configureControlAttr && configureControlAttr.position === 'Manual');

            if (!isManualPosition) return false;

            try {
                const savedData = (typeof getCacheItem === 'function') ? getCacheItem('userPanelPositions') : null;
                if (savedData) {
                    const panelIdKey = (panelId === 'left-panel-2') ? 'leftPanel' :
                        ((panelId === 'right-container') ? 'rightPanel' :
                        ((panelId === 'large-center-panel' || panelId === 'watchlist-table' || panelId === 'search-center-panel') ? 'centralPanel' : null));

                    if (panelIdKey && savedData[panelIdKey] && savedData[panelIdKey].position) {
                        const savedPosStr = savedData[panelIdKey].position;
                        if (defaultPosStr) {
                            const defParts = defaultPosStr.split(' ').map(Number);
                            const savedParts = savedPosStr.split(' ').map(Number);
                            if (defParts.length === 3 && savedParts.length === 3) {
                                const dist = Math.sqrt(
                                    Math.pow(defParts[0] - savedParts[0], 2) +
                                    Math.pow(defParts[1] - savedParts[1], 2) +
                                    Math.pow(defParts[2] - savedParts[2], 2)
                                );
                                return dist > 0.05;
                            }
                        }
                    }
                }
            } catch (e) {
                console.warn('Error checking userPanelPositions', e);
            }
            return false;
        }
    };
})();
